export { default } from './AvatarGroup';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/AvatarGroup/index.js
// module id = 371
// module chunks = 0